import { Briefcase, Home, ShieldCheck, Store } from "lucide-react";
import type { AdminUserRole } from "./types";

export const ROLE_ICON_CONFIG: Record<
  AdminUserRole,
  { icon: typeof Store; className: string }
> = {
  seller: { icon: Store, className: "bg-primary-100 text-primary-600" },
  host: { icon: Home, className: "bg-success-100 text-success-600" },
  "sales-agent": { icon: Briefcase, className: "bg-violet-100 text-violet-600" },
  admin: { icon: ShieldCheck, className: "bg-surface-100 text-surface-600" },
};
